import { render, staticRenderFns } from "./RoomMonitor.vue?vue&type=template&id=523fade6&scoped=true"
import script from "./RoomMonitor.vue?vue&type=script&lang=js"
export * from "./RoomMonitor.vue?vue&type=script&lang=js"
import style0 from "./RoomMonitor.vue?vue&type=style&index=0&id=523fade6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523fade6",
  null
  
)

export default component.exports